package com.tovtalk.ui.components

import androidx.compose.ui.graphics.vector.ImageVector

data class NavigationItem(
    val route: String,
    val label: String,
    val icon: ImageVector,
    val selectedIcon: ImageVector = icon,
    val badgeCount: Int = 0,
    val showBadge: Boolean = false,
    val isCtaButton: Boolean = false
)
